import React from "react";
import NoGeographySelection from "./NoGeographySelection";

interface Props {
  height: number;
  columnCount: number;
}

const NoGeographySelectionTableRow: React.FC<Props> = ({ height, columnCount }) => {
  return (
    <tbody>
      <tr>
        <td colSpan={columnCount}>
          <div style={{ height: height }} className="flex items-center h-48 justify-center w-full">
            <NoGeographySelection />
          </div>
        </td>
      </tr>
    </tbody>
  );
};

export default NoGeographySelectionTableRow;
